













































import {Component, Prop} from 'vue-property-decorator';
import Base from './Base';
import ForgotPasswordModal from '@/components/modals/ForgotPasswordModal.vue';

/**
 * Some documented component
 *
 * @component
 */
@Component({
	components: { ForgotPasswordModal }
})
export default class LoginModeratorMask extends Base {
	@Prop() validation!: any;
  @Prop({default: false}) showForgotPassword!: boolean;
}
